export default __webpack_public_path__ + "static/media/CVpolaroid_TheArtilleryTower.8dd37f30.png";